import { createAction, props } from '@ngrx/store';
import { ResumeItem, ResumeProps } from './resume.models';

export const loadResumes = createAction('[Resume] Load Resumes');

export const loadResumesSuccess = createAction(
  '[Resume] Load Resumes Success',
  props<{ resumes: ResumeItem[] }>()
);

export const loadResumesFailure = createAction(
  '[Resume] Load Resumes Failure',
  props<{ error: any }>()
);

export const ClearResumes = createAction(
  '[Resume] Clear Resume'
);
